import { memoizeFunction } from '@agilepoint/utils-common';

const defaultErrorMessage = 'Error: Something went wrong!';
export const getErrorMessage = memoizeFunction((error: any): string => {
    try {
        if (error) {
            if (typeof(error) === 'string') {
                return error;
            } else if (error && error.stack) {
                return (error).stack || defaultErrorMessage;
            }

            return (error).message || defaultErrorMessage;
        }
        return defaultErrorMessage;
    } catch {
        return defaultErrorMessage;
    }
});
